import AboutXpKnowMoreDialog from './AboutXpKnowMoreDialog';

const FALLBACK_CONTENT = {
  title: 'Know About Passes',
  sections: [
    {
      heading: 'What is Passes?',
      body:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since 1966, when designers at Letraset and James Mosley.",
    },
    {
      heading: 'Passes Benefits',
      items: [
        'Lorem ipsum dolor sit amet, consectetur',
        'Neque porro quisquam est, qui',
        'Dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam',
        'Eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem.',
        'Ut enim ad minima veniam,',
      ],
    },
    {
      heading: 'How to Buy?',
      body:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since 1966, when designers at Letraset and James Mosley.",
    },
  ],
};

/** Figma 10705:3653–3674 — Know About Passes dialog */
export default function PassKnowMoreDialog({ open, onClose }) {
  return <AboutXpKnowMoreDialog open={open} onClose={onClose} slug="pass" fallbackContent={FALLBACK_CONTENT} />;
}
